import {call, put, takeEvery} from 'redux-saga/effects';
import constants from 'constants';
import actions from 'actions';
import axios from 'axios';

const {setZoomAccounts, addRequestError} = actions;

const {GET_ZOOM_ACCOUNTS, API_ZOOM_ACCOUNTS} = constants;

const apiLoadZoomAccount = () => axios.get(API_ZOOM_ACCOUNTS);

function* loadZoomAccount() {
  try {
    const response = yield call(apiLoadZoomAccount);
    const accounts = response.data.accounts;
    if (accounts) {
      const zoomAccountsKeys = Object.keys(accounts);
      const zoomAccounts = zoomAccountsKeys.map(key => ({label: key, value: key}));

      yield put(setZoomAccounts(zoomAccounts));
    }

  } catch (e) {
    yield put(addRequestError(e.response))
  }
}

export function* __loadZoomAccount() {
  yield takeEvery(GET_ZOOM_ACCOUNTS, loadZoomAccount)
}



// WEBPACK FOOTER //
// ./src/sagas/admin/zoom.js